// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
export type ProductDetailFragment = { __typename?: 'Product', id?: string | null, productNumber: string, productKey: string, erpProductKey: string, isSial: boolean, isMarketplace: boolean, marketplaceSellerId?: string | null, marketplaceOfferId?: string | null, erp_type?: Array<string> | null, name: string, displaySellerName?: string | null, description?: string | null, molecularWeight?: string | null, empiricalFormula?: string | null, linearFormula?: string | null, casNumber?: string | null, synonyms: Array<string>, badge?: string | null, materialIds: Array<string>, sdsPnoKey: string, features: Array<string>, paMessage?: string | null, catalogId?: Types.CatalogType | null, substanceCount: number, type?: string | null, customPdpId: string, substance: { __typename?: 'Substance', id: string, key: string }, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null, logo?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null, cells?: { __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string } | null }, aliases: Array<{ __typename?: 'Alias', key: string, value: string, label: string }>, descriptions: Array<{ __typename?: 'ProductDescription', label?: string | null, values: Array<string> }>, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, label?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string, productKey?: string | null, brandKey?: string | null, videoUrl?: string | null }>, keyAttributes?: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string> }> | null, attributes: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string> }>, compliance: Array<{ __typename?: 'Compliance', key?: string | null, label?: string | null, value?: string | null, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, smallUrl: string, mediumUrl: string, largeUrl: string }> }>, complianceReach: Array<{ __typename?: 'ComplianceReach', key?: string | null, label?: string | null, value?: string | null, casNos?: Array<string | null> | null }>, complianceJp: Array<{ __typename?: 'ComplianceJp', id?: string | null, label?: string | null, value?: string | null, seq?: number | null }>, browserMetadata?: { __typename?: 'BrowserMetadata', title?: string | null, description?: string | null, keywords?: Array<string> | null } | null, faqs: Array<{ __typename?: 'FAQ', question: string, answer: string }>, peerPapers: { __typename?: 'Papers', count: number, papers: Array<{ __typename?: 'Paper', id: string, abstract?: string | null, title?: string | null, authors: Array<string>, date?: string | null, pubMedId?: string | null, journalName?: string | null, volume?: string | null, issue?: string | null, startPage?: string | null, endPage?: string | null }> }, links: Array<{ __typename?: 'DocumentLink', label: string, key?: string | null, anchorTag: string, image?: string | null }>, components: { __typename?: 'MappedProductComponent', kitOnly?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, kitSoldSeparate?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null, pno?: string | null, brand?: string | null, erpBrandKey?: string | null, erpPnoKey?: string | null } | null> | null, analyte?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, solvent?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null, bulletin?: Array<{ __typename?: 'ProductComponent', value?: string | null, pId?: string | null } | null> | null }, specificationSheet: { __typename?: 'SpecificationSheet', url?: string | null, text?: string | null }, productCategories: Array<{ __typename?: 'ProductCategory', category: string, url: string } | null>, relatedProducts: Array<{ __typename?: 'RelatedProduct', type: string, productId: string }>, protocolsAndArticles: { __typename?: 'ProtocolsArticles', protocols: Array<{ __typename?: 'ProtocolArticleDocument', id: string, title: string, text?: string | null, url: string, contentType: string } | null>, articles: Array<{ __typename?: 'ProtocolArticleDocument', id: string, title: string, text?: string | null, url: string, contentType: string } | null>, relatedContent: Array<{ __typename?: 'ProtocolArticleDocument', id: string, title: string, text?: string | null, url: string, contentType: string } | null> }, productRating?: { __typename?: 'ProductRating', ratingEnabled?: boolean | null } | null };

export type ProtocolArticleDocumentFragment = { __typename?: 'ProtocolArticleDocument', id: string, title: string, text?: string | null, url: string, contentType: string };

export type PaperDetailsFragment = { __typename?: 'Papers', count: number, papers: Array<{ __typename?: 'Paper', id: string, abstract?: string | null, title?: string | null, authors: Array<string>, date?: string | null, pubMedId?: string | null, journalName?: string | null, volume?: string | null, issue?: string | null, startPage?: string | null, endPage?: string | null }> };

export const PaperDetailsFragmentDoc = gql`
    fragment PaperDetails on Papers {
  count
  papers {
    id
    abstract
    title
    authors
    date
    pubMedId
    journalName
    volume
    issue
    startPage
    endPage
  }
}
    `;
export const ProtocolArticleDocumentFragmentDoc = gql`
    fragment ProtocolArticleDocument on ProtocolArticleDocument {
  id
  title
  text
  url
  contentType
}
    `;
export const ProductDetailFragmentDoc = gql`
    fragment ProductDetail on Product {
  id
  productNumber
  productKey
  erpProductKey
  isSial
  isMarketplace
  marketplaceSellerId
  marketplaceOfferId
  erp_type
  substance {
    id
    key
  }
  brand {
    key
    erpKey
    name
    logo {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    cells {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
    color
  }
  aliases {
    key
    value
    label
  }
  name
  displaySellerName
  description
  descriptions {
    label
    values
  }
  molecularWeight
  empiricalFormula
  linearFormula
  casNumber
  images {
    altText
    label
    smallUrl
    mediumUrl
    largeUrl
    productKey
    brandKey
    videoUrl
  }
  synonyms
  badge
  keyAttributes {
    key
    label
    values
  }
  attributes {
    key
    label
    values
  }
  materialIds
  compliance {
    key
    label
    value
    images {
      altText
      smallUrl
      mediumUrl
      largeUrl
    }
  }
  complianceReach {
    key
    label
    value
    casNos
  }
  complianceJp {
    id
    label
    value
    seq
  }
  browserMetadata {
    title
    description
    keywords
  }
  sdsPnoKey
  faqs {
    question
    answer
  }
  peerPapers {
    ...PaperDetails
  }
  links {
    label
    key
    anchorTag
    image
  }
  features
  paMessage
  catalogId
  components {
    kitOnly {
      value
      pId
      pno
      brand
      erpBrandKey
      erpPnoKey
    }
    kitSoldSeparate {
      value
      pId
      pno
      brand
      erpBrandKey
      erpPnoKey
    }
    analyte {
      value
      pId
    }
    solvent {
      value
      pId
    }
    bulletin {
      value
      pId
    }
  }
  specificationSheet {
    url
    text
  }
  substanceCount
  productCategories {
    category
    url
  }
  relatedProducts {
    type
    productId
  }
  type
  customPdpId
  protocolsAndArticles {
    protocols {
      ...ProtocolArticleDocument
    }
    articles {
      ...ProtocolArticleDocument
    }
    relatedContent {
      ...ProtocolArticleDocument
    }
  }
  productRating {
    ratingEnabled
  }
}
    ${PaperDetailsFragmentDoc}
${ProtocolArticleDocumentFragmentDoc}`;